module.exports = __webpack_public_path__ + "src/assets/img/spriteAnimalAutruche.png";